import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=b0949c92&scoped=true"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"
import style0 from "./Textarea.vue?vue&type=style&index=0&id=b0949c92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0949c92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0949c92')) {
      api.createRecord('b0949c92', component.options)
    } else {
      api.reload('b0949c92', component.options)
    }
    module.hot.accept("./Textarea.vue?vue&type=template&id=b0949c92&scoped=true", function () {
      api.rerender('b0949c92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/back/Survey/Textarea.vue"
export default component.exports